import { useCallback } from 'react';

import useEnum from '@hooks/useEnum';

import CaixaService from '@services/CaixaService';

const useStatusCaixa = () => {
    const fetch = useCallback(() => CaixaService.listarStatus(), []);
    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useStatusCaixa;